module.exports = __webpack_public_path__ + "static/media/97lintas.ea357c80.png";